/* Elihome Careers page: Apply Now reveals the application form for that position.
   Deep link: /pages/careers#apply-<job-title-handle> opens the form directly. */
(function () {
  if (window.ElihomeCareers) return;

  function openPanel(panel, button, scroll) {
    panel.classList.add('is-open');
    if (button) button.setAttribute('aria-expanded', 'true');

    var job = panel.closest('details');
    if (job && !job.open) job.open = true;

    if (scroll) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var heading = panel.querySelector('[data-careers-apply-heading]');
      if (heading) heading.focus({ preventScroll: true });
    }
  }

  function bind(root) {
    var buttons = root.querySelectorAll('[data-careers-apply-button]');
    Array.prototype.forEach.call(buttons, function (button) {
      if (button.hasAttribute('data-careers-bound')) return;
      button.setAttribute('data-careers-bound', '');

      button.addEventListener('click', function (event) {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        event.preventDefault();
        openPanel(panel, button, true);
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + panel.id);
        }
      });
    });
  }

  function openFromHash() {
    if (!window.location.hash) return;
    var target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (!target) return;

    if (target.hasAttribute('data-careers-apply-panel')) {
      var button = document.querySelector('[aria-controls="' + target.id + '"]');
      openPanel(target, button, true);
    } else if (target.hasAttribute('data-careers-job')) {
      target.open = true;
    }
  }

  function init() {
    bind(document);
    openFromHash();
  }

  window.ElihomeCareers = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var job = event.target.closest && event.target.closest('[data-careers-job]');
    if (job) job.open = true;
  });
})();
